// Module
var code = "<div class=\"signup\"> <sign-up-component></sign-up-component> </div> ";
// Exports
module.exports = code;